import React from "react";
import {
  CustomAmountInput,
  CustomCalander,
  CustomDropDown,
  CustomForm,
  CustomInput,
  CustomRadioInput,
} from "shared/AllInputs";
import AddExtraCost from "shared/Components/AddExtraCost";
import { IntervalType, RentType } from "shared/AllDropDownOptions";
import EuroIcon from "assets/images/svg/euroIcon.svg"
import { isFirstDayOfMonth } from "utils/commonFunctions";
const RentAndCost = ({
  title,
  data,
  handleChange,
  allExtraCost,
  setAllExtraCost,
  movingInDate,
}) => {
  return (
    <>
      <CustomForm title={title || "Contractual Rent"}>
        <CustomAmountInput
          data={data}
          onChange={handleChange}
          name="amount"
          required
          spanIcon={EuroIcon}
        />
        <CustomAmountInput
          data={data}
          onChange={handleChange}
          name="amountFirstMonth"
          required={!isFirstDayOfMonth(movingInDate)}
          spanIcon={EuroIcon}
        />
      </CustomForm>
      <CustomForm title="Automatic Rent Increment">
        <CustomDropDown
          data={data}
          onChange={handleChange}
          name="rentRiseType"
          options={RentType}
          required
        />
      </CustomForm>
      {data?.rentRiseType === "None" || data?.rentRiseType == "" ? null : (
        <CustomForm>
          <CustomDropDown
            data={data}
            onChange={handleChange}
            name="intervalType"
            options={IntervalType}
            required
            label={"Rent Rise Interval Type"}
          />
          <CustomInput
            data={data}
            onChange={handleChange}
            name="riseInterval"
            label={"Rent Rise Interval"}
            required
          />
          <CustomCalander
            data={data}
            onChange={handleChange}
            name="startDate"
            label="Date of First Rise"
            required
          />

          <CustomAmountInput
            data={data}
            onChange={handleChange}
            name="riseAmount"
            label="Rent Rise Amount"
            spanIcon={EuroIcon}
            required
          />
          <CustomCalander
            minDate={data?.startDate}
            data={data}
            onChange={handleChange}
            name="endDate"
            label="Date of Last Rise"
            required
          />
        </CustomForm>
      )}
      <AddExtraCost
        // type={type}
        allExtraCost={allExtraCost}
        setAllExtraCost={setAllExtraCost}
        movingInDate={movingInDate}
        // errors={costErrors}
        // setErrors={setCostErrors}
      />
      {data?.propertyRent && <CustomForm title={"Property Rent"}>
        <CustomRadioInput
          extraClassName="w-25rem"
          inputClass="mr-2"
          name="propertyRent"
          value="Size"
          label={<div className="inline-block">By Size</div>}
          onChange={handleChange}
          checked={data?.propertyRent === "Size"}
        />
        <CustomRadioInput
          extraClassName="w-25rem"
          inputClass="mr-2"
          name="propertyRent"
          value="Room"
          label={<div className="inline-block">By rooms</div>}
          onChange={handleChange}
          checked={data?.propertyRent === "Room"}
        />
        <CustomRadioInput
          extraClassName="w-25rem"
          inputClass="mr-2"
          name="propertyRent"
          value="Manually"
          label={<div className="inline-block">Manually Enter</div>}
          onChange={handleChange}
          checked={data?.propertyRent === "Manually"}
        />
      </CustomForm>}
      {/* <CustomInput
        col={6}
        data={data}
        onChange={handleChange}
        name="calculatedRent"
        required
      /> */}
    </>
  );
};

export default React.memo(RentAndCost);
